import React, { ChangeEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import imageCompression from 'browser-image-compression'
import heic2any from 'heic2any'
import { blobToFile } from 'utils/blobToFile'
import { convertWebPToJpeg } from 'utils/convertWebPToJpeg'

enum AppInputFileView {
  link = 'link',
}

export enum AppInputFileColor {
  violet = '',
  gray = 'gray',
}
const options = {
  maxSizeMB: 0.5, // Максимальный размер 0.5 MB
  maxWidthOrHeight: 800, // Уменьшение размера изображения
  useWebWorker: true,
}
interface IAppInputFileProps {
  color?: AppInputFileColor
  text?: string
  view?: AppInputFileView
  onChangeFile: (file: File | null) => void
  setLoading?: (loading: boolean) => void
  setLoadingConversion?: (loading: boolean) => void
  setFilePreview?: (value: string) => void
  extraText?: string
}
// проверка изображение или нет
const isImage = (file: File): boolean => {
  const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
  return validTypes.includes(file.type)
}
export const AppInputFile = ({
  color = AppInputFileColor.violet,
  view = AppInputFileView.link,
  text,
  onChangeFile,
  setLoading,
  setLoadingConversion,
  setFilePreview,
  extraText,
}: IAppInputFileProps) => {
  const { t } = useTranslation()
  const [inputValue, setInputValue] = useState('')
  const changeHandler = async (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setFilePreview && setFilePreview('')
    let file = e.target.files && e.target.files[0]

    setInputValue('')

    if (!file) return

    //  Если файл HEIC, сначала конвертируем его в JPEG
    if (file.name.toLocaleLowerCase().endsWith('.heic')) {
      setLoadingConversion && setLoadingConversion(true)
      try {
        const imageBlob = (await heic2any({
          blob: file,
          toType: 'image/jpeg', // Конвертация в JPEG
        })) as Blob
        file = blobToFile(imageBlob, file.name.replace(/\.heic$/i, '.jpg'))
      } catch (error) {
        setLoadingConversion && setLoadingConversion(false)
        console.error('Ошибка сжатия:', error)
      }

      setLoadingConversion && setLoadingConversion(false)
    }
    if (file.type === 'image/webp') {
      setLoadingConversion && setLoadingConversion(true)
      file = await convertWebPToJpeg(file)
      setLoadingConversion && setLoadingConversion(false)
    }
    if (isImage(file)) {
      setLoading && setLoading(true)
      try {
        const compressedFile = await imageCompression(file, options)
        onChangeFile(compressedFile)
        setLoading && setLoading(false)
      } catch (error) {
        console.error('Ошибка сжатия:', error)
        setLoading && setLoading(false)
      }
    } else {
      onChangeFile(file)
    }
  }

  return (
    <>
      <label className={`file-input-label ${color}`}>
        {t(text || 'выберите файл')}

        <input
          value={inputValue}
          type="file"
          className="file-input"
          onChange={changeHandler}
        />
      </label>
      <span> {extraText}</span>
    </>
  )
}
